module.exports = __webpack_public_path__ + "img/airline-pdf.08e4d754.svg";